import React from "react";
import about5Webp from "./footerimg/about-5.webp";
import { auto } from "@popperjs/core";

const missionCards = [
  {
    title: "Support Healthcare Providers",
    description:
      "Provide specialties data to clinics, hospitals, labs, diagnostic centers, and pharmacies with advanced tools to improve their operations and enhance patient care.",
    icon: "bi-activity",
  },
  {
    title: "Enhance Workflow & Patient Experiences",
    description:
      "Utilize advanced tools and data analytics to streamline operations. Improve patient satisfaction by streamlining procedures and guaranteeing prompt, precise medical services.",
    icon: "bi-diagram-3",
  },
  {
    title: "Guarantee Quality and Adherence to Standards",
    description:
      "Implement robust quality assurance processes and adhere to industry standards to ensure the highest level of care and compliance.",
    icon: "bi-easel",
  },
  {
    title: "Encourage Innovation through the R&D Team",
    description:
      "Foster a culture of innovation by empowering the R&D team to explore new ideas and technologies. Invest in research and development to stay ahead in the healthcare industry.",
    icon: "bi-clipboard-data",
  },
];

const AboutUsSection = () => {
  return (
    <div>

  
    <div className="container">
      <section className="container mt-3">
        
        <div
          className="row justify-content-between align-items-center"
          style={{ marginTop: "40px" }}
        >
          {/* Left Side - Text Content (col-xl-5) */}
          <div className="col-xl-5 col-lg-6 mb-4 mb-lg-0">
            <span
              className="about-meta fw-bold small"
              style={{ color: "#0d622b" }}
            >
              MORE ABOUT US
            </span>
            <h3
              className="about-title fw-bold mt-2"
              style={{ lineHeight: "1.2", color: "#2d465e" }}
            >
              Our vision is to leverage technology <br /> to transform
              healthcare service providers
            </h3>
            <p className="about-description text-start mt-3">
              making it more efficient, accessible, and patient-centric. At Log
              e Infotech, we believe in empowering healthcare providers with
              cutting-edge software solutions that enable them to deliver
              personalized care, optimize workflows, and improve patient
              outcomes.
            </p>

            {/* Feature Points Section */}
            <div className="row feature-list-wrapper mt-4">
              <div className="col-md-6">
                <ul className="feature-list list-unstyled ps-0">
                  <li className="d-flex align-items-center mb-2">
                    <i
                      className="bi bi-check-circle-fill me-2"
                      style={{ color: "#0d622b" }}
                    ></i>
                    Automated Data Processing
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <i
                      className="bi bi-check-circle-fill me-2"
                      style={{ color: "#0d622b" }}
                    ></i>
                    Predictive Analytics
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <i
                      className="bi bi-check-circle-fill me-2"
                      style={{ color: "#0d622b" }}
                    ></i>
                    Government Portals Integration
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="feature-list list-unstyled ps-0">
                  <li className="d-flex align-items-center mb-2">
                    <i
                      className="bi bi-check-circle-fill me-2"
                      style={{ color: "#0d622b" }}
                    ></i>
                    Lab Integration
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <i
                      className="bi bi-check-circle-fill me-2"
                      style={{ color: "#0d622b" }}
                    ></i>
                    Streamlined Workflows
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <i
                      className="bi bi-check-circle-fill me-2"
                      style={{ color: "#0d622b" }}
                    ></i>
                    Data Security Measures
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Side - Image Collage (col-xl-6 for better spacing 'between') */}
          <div className="col-xl-6 col-lg-6 d-flex justify-content-center justify-content-xl-end position-relative">
            <img
              src={about5Webp}
              alt="Team Member"
              className="about-team-img img-fluid rounded"
            />
          </div>
        </div>

        {/* Founders Section */}
        <div className="row gy-4 mt-4 founders-section">
          <div className="col-auto d-flex align-items-center gap-3">
            <img
              src="/assets/img/user2.png"
              alt="Mr. Vikas Mahurkar"
              className="profile-image rounded-circle"
            />
            <div>
              <h5 className="profile-name mb-0">Mr. Vikas Mahurkar</h5>
              <p className="profile-position text-success small mb-0">
                CEO & Founder
              </p>
            </div>
          </div>
          <div className="col-auto d-flex align-items-center gap-3">
            <img
              src="/assets/img/user1.png"
              alt="Dr. Anagha Mahurkar"
              className="profile-image rounded-circle"
            />
            <div>
              <h5 className="profile-name mb-0">Dr. Anagha Mahurkar</h5>
              <p className="profile-position text-success small mb-0">
                Director & Admin
              </p>
            </div>
          </div>
        </div>

        {/* Styles */}
        <style jsx>{`
          .about-meta {
            letter-spacing: 1px;
          }
          .about-title {
            color: #2d465e;
          }
          .about-description {
            color: #212529;
          }
          .feature-list li {
            font-size: 0.9rem;
          }
          .feature-list li i {
            font-size: 1.1rem;
            min-width: 24px;
          }
          .about-team-img {
            max-width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          }
          .profile-image {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border: 2px solid #0d622b;
          }
          @media (min-width: 1200px) {
            .about-team-img {
              width: 600px; /* विड्थ को थोड़ा कम किया ताकि space-between साफ दिखे */
              height: 400px;
            }
          }
        `}</style>
      </section>
      <section id="mission" className="py-5">
        <div className="container">
          <div
            className="text-center mb-5"
            style={{ maxWidth: 700, margin: "0 auto" }}
          >
            <h1 className="h3 fw-bold  mb-3" style={{ color: "#2d465e" }}>
              Our Mission
            </h1>
            <div
              className="mx-auto mb-4"
              style={{
                width: 64,
                height: 4,
                background: "#0d622b",
                borderRadius: 8,
              }}
            ></div>
            <p className="lead text-muted">
              Our goal is to consistently advance and improve our platform to
              address the changing requirements of the healthcare sector. We
              strive to
            </p>
          </div>
          <div className="row">
            {missionCards.map((card, index) => (
              <div className="col-12 col-lg-6 mb-4" key={index}>
                <div className="bg-white rounded-4 p-4 shadow h-100">
                  <div className="d-flex align-items-start mb-3">
                    <span className="bg-success bg-opacity-10 rounded-3 p-3 me-3">
                      <i className={`bi ${card.icon} fs-3 text-white`}></i>
                    </span>
                    <div>
                      <h4
                        className="fw-semibold mb-2"
                        style={{ color: "#2d465e" }}
                      >
                        {card.title}
                      </h4>
                      <p className="text-muted mb-3">{card.description}</p>
                      #0d622b
                      <a
                        href="#read-more"
                        className=" fw-medium text-decoration-underline"
                        style={{ color: "#0d622b" }}
                      >
                        Read More <i className="bi bi-arrow-right ms-1"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
     
    </div>
     <section id="about-us-cta" className="about-us-cta section py-0">
  {/* यह div "cta-container" अब पूरे स्क्रीन की चौड़ाई लेगा */}
  <div className="cta-container">
    {/* यह "container" कंटेंट को बीच (Center) में रखेगा */}
    <div className="container position-relative">
      <div className="row content justify-content-center align-items-center" style={{ zIndex: 5 }}>
        <div className="col-lg-8 mx-auto text-center">
          <h2 className="display-6 mb-4 text-white">Why Choose Log e Infotech?</h2>
          <p className="mb-4 text-white">
            At Log e Infotech Pvt. Ltd., our commitment to transforming
            healthcare is built on innovation, expertise, and an
            understanding of patient-centric care. Our solutions empower
            medical staff, streamline operations, and improve outcomes
            across every segment of the healthcare industry.
          </p>
          <button className="view-button" onClick={() => window.location.href="#/about/"}>
            Learn More About Us
          </button>
        </div>

        {/* Decorative SVG shapes - ये अब किनारे तक फैलेंगे */}
        <div className="shape shape-1">
          <svg viewBox="0 0 200 200" fill="white">
            <path d="M47.1,-57.1C59.9,-45.6,68.5,-28.9,71.4,-10.9C74.2,7.1,71.3,26.3,61.5,41.1C51.7,55.9,35,66.2,16.9,69.2C-1.3,72.2,-21,67.8,-36.9,57.9C-52.8,48,-64.9,32.6,-69.1,15.1C-73.3,-2.4,-69.5,-22,-59.4,-37.1C-49.3,-52.2,-32.8,-62.9,-15.7,-64.9C1.5,-67,34.3,-68.5,47.1,-57.1Z" transform="translate(100 100)" />
          </svg>
        </div>
        <div className="shape shape-2">
          <svg viewBox="0 0 200 200" fill="white">
            <path d="M41.3,-49.1C54.4,-39.3,66.6,-28.7,71.1,-15.3C75.6,-1.9,72.4,14.4,63.8,27.1C55.2,39.8,41.1,49,26.1,54.3C11.1,59.5,-4.8,60.8,-21,57.5C-37.2,54.2,-53.7,46.2,-62.1,32.8C-70.5,19.4,-70.8,0.5,-65.4,-15.8C-60,-32,-48.9,-45.6,-35.3,-55.2C-21.7,-64.8,-5.6,-70.4,7.8,-68.8C21.2,-67.2,33.1,-58.4,41.3,-49.1Z" transform="translate(100 100)" />
          </svg>
        </div>
      </div>
    </div>
  </div>

      <style jsx="true">{`
  .about-us-cta {
   background: linear-gradient(to right, #A3CFBB); 
  }

  .about-us-cta .cta-container {
  background: linear-gradient(to right, #A3CFBB); 
    color: white !important;
    position: relative;
    overflow: hidden;
    /* Full Width के लिए ये बदलाव करें:
    border-radius: 0 !important;   
    padding: 5rem 0;               
    width: 100%;
    margin: 0;
  }

  .about-us-cta h2, .about-us-cta p {
    color: white !important;
  }

  /* Shapes की पोजीशन को किनारे पर सेट करना */
  .shape {
    position: absolute;
    opacity: 0.15;
    z-index: 1;
    pointer-events: none;
  }

  .shape-1 {
    left: -50px;
    bottom: -50px;
    width: 250px;
  }

  .shape-2 {
    right: -50px;
    top: -50px;
    width: 300px;
  }

  @media (max-width: 768px) {
    .about-us-cta .cta-container {
      padding: 3rem 1rem;
    }
    .shape {
      display: none;
    }
  }
`}</style>
      </section>
    </div>
  );
};

export default AboutUsSection;